import {z} from '@hono/zod-openapi';

export const serviceIntervalSummaryResponseSchema = z.object({
  // Advisor-facing summary as 1–2 plain-prose paragraphs (no headings, no actions).
  summary: z.array(z.string()),
});

export type ServiceIntervalSummaryResponse = z.infer<typeof serviceIntervalSummaryResponseSchema>;
